import {forward} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {TokenStorage} from 'core/tokenStorage';

import {
    registerError$,
    cleanRegisterDataFx,
    cleanRegisterData,
    cert$,
    setCert,
    RegisterGate,
    registrationFx,
    // organization$,
    // setOrganization,
    loginFx,
} from './index';

registerError$
    .on(registrationFx.failData, (state, {message}) => message)
    .reset(registrationFx.done);

cert$.on(setCert, (state, payload) => payload).reset(RegisterGate.close);
// organization$.on(setOrganization, (state, payload) => payload).reset(RegisterGate.close);

forward({
    from: cleanRegisterData,
    to: cleanRegisterDataFx,
});

loginFx.doneData.watch(([authData, saveCredentials]) =>
    TokenStorage.storeTokens(authData, saveCredentials),
);

registrationFx.failData.watch((err) => showRestError(err as RestError));
